var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"row-key":"fileDownUrl","loading":_vm.loading,"columns":_vm.columns,"data-source":_vm.tableList,"pagination":false},scopedSlots:_vm._u([{key:"action",fn:function(text, record){return [_c('a',{attrs:{"href":record.fileDownUrl,"download":"","target":"_self"}},[_vm._v("下载")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }